<div class="flex flex-column w-full h-full align-content-between">
  <div class="flex mb-4 gap-2 w-full">
    <toolbar class="w-full" title="Groupes"></toolbar>
  </div>
  <div class="alm-card p-0 mb-4 border-round-2xl shadow-1 transition-all transition-duration-300 hover:shadow-3 bg-white">
    <div class="bg-white border-round-bottom-xl m-4 border-3 border-gray-100">
        <dynamic-table [headers]="columns" [data]="groups" [pageParams]="pageable"
                    [actions]="actions" (paginate)="onPageChange($event)"></dynamic-table>
    </div>
  </div>
</div>
